import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ICatTipoUnidades from '../../../Interfaces/Catalogos/ICatTipoUnidades'
const CatTipoUnidades: ICatTipoUnidades[] = []
const initialState = { CatTipoUnidades }

export const CatTipoUnidadesSlice = createSlice({
  name: 'CatTipoUnidades',
  initialState: initialState,
  reducers: {
    resetCatTipoUnidades : (state, action: PayloadAction<string>) => {
      state.CatTipoUnidades =  []
    },  
    populateCatTipoUnidades : (state, action: PayloadAction<ICatTipoUnidades[]>) => {
        action.payload.forEach(element => {
            const index = state.CatTipoUnidades.findIndex(object => object.id === element.id)
            if (index<0) state.CatTipoUnidades.push(element)
        })
    },
    updateCatTipoUnidades : (state, action: PayloadAction<ICatTipoUnidades>) => {
      const i = state.CatTipoUnidades.findIndex(_element => _element.id === action.payload.id);
      if (i > -1) state.CatTipoUnidades[i] = action.payload;
      else state.CatTipoUnidades.push(action.payload);
    },
    deleteCatTipoUnidades : (state, action: PayloadAction<number>) => {
      const newArr = state.CatTipoUnidades.filter(data => data.id != action.payload);
      state.CatTipoUnidades=newArr
    },
  },
})

export const { resetCatTipoUnidades, populateCatTipoUnidades, updateCatTipoUnidades, deleteCatTipoUnidades } = CatTipoUnidadesSlice.actions;
export default CatTipoUnidadesSlice.reducer;